import { Injectable } from '@angular/core';
import { GetAnexoByIDResponse } from '../models/Anexo';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor() { }

  openFileFromOctectStream(response: GetAnexoByIDResponse, download?: boolean) {
    const filename = this.ensureFilename(response.filename);
    const extension = filename.split('.').pop() || '';

    // Get the MIME type for the extension
    const mimeType = response.blob.type || this.getMimeType(extension);

    // Create a new Blob with the correct MIME type
    const newBlob = new Blob([response.blob], { type: mimeType });

    // Create a URL for the Blob and open it in the browser
    const url = URL.createObjectURL(newBlob);

    // Check if the MIME type is one that can be rendered in the browser
    const renderableTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/gif'];

    if (download) {
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      if (renderableTypes.includes(mimeType)) {
        window.open(url);
      } else {
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }

    // Evita cancelar la descarga en Chromium: revocar demasiado pronto puede abortarla.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  }

  private ensureFilename(filename: string): string {
    const trimmed = (filename || '').trim();

    if (!trimmed) {
      return 'anexo';
    }

    // Previene nombres inválidos para descarga en distintos sistemas.
    return trimmed.replace(/[\\/:*?"<>|]/g, '_');
  }

  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'pdf': 'application/pdf',
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'txt': 'text/plain',
    };

    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }
}
